export const AVAILABLE_SKIN_COLORS = ["#d0b4a8", "#c2a482", "#b08759", "#947159", "#855a32", "#57351d", "#2c1e0b"]

export const AVAILABLE_HAIR_COLORS = ["#debe99", "#af855f", "#3d2107", "#20150b", "#0a0a0a", "#9a3300", "#f593df"]
